import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Switch } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import CustomTableGrid from 'components/uiComponents/CustomTableGrid';
import FormikControl from 'components/wrapperComponents/FormikControl';
import { msgTypes } from 'constants/msgTypes';
import { Form, Formik } from 'formik';
import { AnnouncementModel } from 'model/screensModels/AnnouncementModel';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import { RequestModel } from 'model/utilModels/RequestModel';
import { ResponseModel } from 'model/utilModels/ResponseModel';
import { useEffect, useMemo, useState } from 'react';
import { LocalStorageService } from 'services/auth/LocalStorageService';
import { AnnouncementService } from 'services/menu/announcementService/AnnouncementService';
import { conformationAlert } from 'services/shared/alert';
import ApiUrl from 'services/shared/ApiUrl';



export const NewsAnnouncementList = ({ setFlag, updateRecord, loadRecentAnnouncement }) => {

    const [announcementList, setAnnouncementList] =  useState<ResponseModel | null>(null); 
    const paginatorModel: PaginatorModel = new PaginatorModel();
    const [role, setRole] = useState(undefined);
    const [pagination, setPagination] = useState({
        pageSize: paginatorModel.pageSize,
        pageNumber: paginatorModel.pageNumber,
        filter: "",
        orderBy: "",
        desc: "",
    })

    const columns = useMemo(() =>
        [
            {
                header: 'Attachment',
                Cell: ({ renderedCellValue, row }) => (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <img alt="avatar" height={35} width={35} src={row.original.attachment ? ApiUrl.fileBaseUrl + row.original.attachment + "/" : "/image/userimage.jpg"} loading="lazy" />
                    </Box>
                ),
                size: 50
            },
            {
                accessorKey: "title",
                header: "Title",
                size: 150
            },
            {
                accessorKey: "message",
                header: "Message",
                size: 200
            },
        {
    accessorKey: "status",
    header: "Status",
    size: 50,
    Cell: ({ row }) => {
        const status = row.original.status;
        return (
            <Box
                sx={{
                    color: status ? "#4CAF50" : "#FFC107", // Green for Approved, Yellow for Pending
                
           
                
                    fontWeight: "bold",
                }}
            >
                {status ? "Approved" : "Pending"}
            </Box>
        );
    }
},
            {
                header: 'Action',
                Cell: ({ renderedCellValue, row }) => (
                  <div className='d-flex'>
                    {/* <EditIcon onClick={()=>{editRecord(row.original)}} color='primary'/> */}
                    <Tooltip title="Edit">
                      <EditIcon fontSize="small" onClick={() => { editRecord(row.original) }} />
                    </Tooltip>
                    <Tooltip title="Delete">
                      <DeleteIcon fontSize="small" onClick={() => { deleteRecord(row.original) }} />
                    </Tooltip>
                  </div>
                ),
                size: 10,
                grow: false,
              },

        ], []);



    const getUserRole = async () => {
        const role = await LocalStorageService.getUserRole();
        setRole(role);
    }


    useEffect(() => {
        getUserRole();
        getAnnouncementList();
    }, [pagination.pageNumber, pagination.pageSize, pagination.filter, pagination.orderBy, pagination.desc])


    const updateStatus = async (record: AnnouncementModel) => {
        record.status = !record.status;
        const updateStatusFlag = await conformationAlert(
            msgTypes.CONFORMATION_MESSAGE.UPDATE_RECORD,
            msgTypes.CONFORMATION_ICON.ERROR,
            "Yes! Update"
        );
        if (updateStatusFlag) {
            const res = await AnnouncementService.saveAnnouncement(record)
            if (res.statusMsg === msgTypes.SUCCESS.msg) {
                getAnnouncementList();
            }
        }
    };


    const prepareRequest = async () => {
        const requestBody = new RequestModel();
        requestBody.pageNumber = pagination.pageNumber;
        requestBody.pageSize = pagination.pageSize;
        requestBody.filter = pagination.filter;
        requestBody.orderBy = pagination.orderBy;
        requestBody.desc = pagination.desc;

        //get Company Id
        const userDetails = await LocalStorageService.getUserDetails();
        if (userDetails !== '') {
            const companyDetails = JSON.parse(userDetails)
            requestBody.companyId = companyDetails.companyId;
        }

        return requestBody;
    }

    //Get Announcement list
    const getAnnouncementList = async () => {
        const requestBody = await prepareRequest();
        const res = await AnnouncementService.getAnnouncementList(requestBody);
        if (res.statusMsg === msgTypes.SUCCESS.msg) {
            setAnnouncementList(res)
        }
    }



    const editRecord = (record: AnnouncementModel) => {
        updateRecord(record);
        setFlag(true)
    }

    const deleteRecord = async (record: AnnouncementModel) => {
        const requestData: AnnouncementModel = new AnnouncementModel();
        requestData.announcementId = record.announcementId
        const deleteFlag = await conformationAlert(msgTypes.CONFORMATION_MESSAGE.DELETE_RECORD, msgTypes.CONFORMATION_ICON.ERROR, "delete");
        if (deleteFlag) {
            const res = await AnnouncementService.deleteAnnouncement(requestData);
            if (res.statusMsg === msgTypes.SUCCESS.msg) {
                getAnnouncementList();
                loadRecentAnnouncement();
            }
        }
    }

    const initialValues = {}
    const onSubmit = () => {
        getAnnouncementList();
    }


    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={onSubmit}
        >
            {
                formik =>
                (
                    <Form>
                           {announcementList ? (
                        <CustomTableGrid
                            item={
                                <FormikControl
                                    control='materialTable'
                                    tableColumn={columns}
                                    tableData={announcementList}
                                    setPagination={setPagination}
                                />
                            }
                        />
                    ) : null}
                    </Form>
                )
            }
        </Formik>
    )
}
